import React from 'react';
import ".././css/waves.css";
import ".././css/footer.css";


function Footer() {
    return (
    <div>
        <div className="waves">
            <div className="wave wave1"></div>
            <div className="wave wave2"></div>
            <div className="wave wave3"></div>
            <div className="wave wave4"></div>
        </div>
        <div className="footer-dark">
            <footer>
                <div className="container">
                    <div className="rowFoot">
                        <div className="col">
                            <h3>Services</h3>
                            <ul>
                                <li><a href="#">Web design</a></li>
                                <li><a href="#">Development</a></li>
                                <li><a href="#">Hosting</a></li>
                            </ul>
                        </div>
                        <div className="col">
                            <h3>About</h3>
                            <ul>
                                <li><a href="#">Company</a></li>
                                <li><a href="#">Team</a></li>
                                <li><a href="#">Careers</a></li>
                            </ul>
                        </div>
                        <div className="col">
                            <h3>Company Name</h3>
                            <p>Novuservers</p>
                        </div>
                        <div className="col item social">
                            <a href="https://www.facebook.com/">
                                <i className="icon ion-social-facebook"></i>
                            </a>
                            <a href="https://twitter.com/">
                                <i class="icon ion-social-twitter"></i>
                            </a>
                            <a href="https://discord.gg/3psXdAZ5hY">
                                <i class="icon ion-social-discord"></i>
                            </a>
                            <a href="https://www.instagram.com/">
                                <i class="icon ion-social-instagram"></i>
                            </a>
                        </div>
                    </div>
                    <p className="col-sm">
                        &copy;{new Date().getFullYear()} Novuservers | All rights reserved |
                        Terms Of Service | Privacy Policy
                     </p> 
                </div> 
            </footer>
        </div>
    </div>
  );
}

export default Footer;


